import { UnassignedBillLink as UnassignedBillLinkPure } from './UnassignedBillLink';
import { connectUnassignedBillLink } from './connectUnassignedBillLink';

export const UnassignedBillLink = connectUnassignedBillLink(UnassignedBillLinkPure);
